<template>
 <div class="block-free d-flex flex-wrap">
    <div class="block-free__items w-100 mr-4 mt-2 px-2 d-flex align-items-center" v-for="(item, index) in freeItems"
      :key="index">
      <div class="d-flex">
        <input placeholder="название услуги" type="text" autocomplete="off" class="form-control w-75" v-model="item.name">
        <input placeholder="цена" type="text" autocomplete="off" class="form-control ml-2 w-25" @blur="checkPrice(item)" v-model="item.value">
      </div>
      <button type="button" class="btn btn-sm btn-outline-primary ml-2" @click="removeItem(item)"><i class="ico ico-delete px-2"></i></button>
    </div>
    <div class="block-free__add-item mt-2">
      <button class="btn btn-sm btn-primary mx-3" @click="addItem"><i class="ico ico-plus px-2"></i></button>
    </div>
  </div>
</template>
<script>

export default {
  name: 'CalculatePriceBlockFree',
  props: {
    blockName: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      freeItems: []
    }
  },
  methods: {
    addItem () {
      this.freeItems.push({ name: '', value: null, blockName: this.blockName })
    },
    removeItem (item) {
      const index = this.freeItems.indexOf(item)
      this.freeItems.splice(index, 1)
    },
    checkPrice (item) {
      const index = this.freeItems.indexOf(item)
      const value = this.freeItems[index].value.replace(',', '.')
      this.freeItems[index].value = +(isNaN(value) ? 0 : value)
      this.freeItems.splice(index, 1, item)
    }
  },
  watch: {
    freeItems: {
      handler: function (newValue) {
        if (newValue.length > 0) {
          this.$emit('updateFreeItems', newValue)
        } else {
          this.$emit('updateFreeItems', undefined)
        }
      },
      deep: true
    }
  },
  created () {
    this.freeItems.push({ name: '', value: null, blockName: this.blockName })
    this.$emit('updateFreeItems', undefined)
  }
}
</script>

<style lang="scss" scoped>
.block-format {
  &__format-btn {
    cursor: pointer;
    position: relative;
    height: 38px;
    min-width: 80px;
    border-radius: 4px;
    box-shadow: inset 0 1px 0 rgba(40, 189, 139, 0.15);
    background-color: #e9f8f3;
    color: #28bd8b;
    max-width: 400px;

    &.selected {
      background-color: #28bd8b;
      color: #fff;
    }
  }

  &__format-input {
    max-width: 200px;
  }
}
</style>
